/* ==========================================================================
   ORKA — accordion
   --------------------------------------------------------------------------
   One open row at a time per group. Opening a row closes whichever row in the
   same [data-orka-accordion] container was open.

   Markup contract:
     <div data-orka-accordion>
       <div class="orka-accordion__item">
         <button class="orka-accordion__summary" aria-expanded="false" aria-controls="ID">…</button>
         <div class="orka-accordion__panel" id="ID"><div class="orka-accordion__panel-inner">…</div></div>
       </div>
     </div>

   Height animation is pure CSS (grid-template-rows 0fr → 1fr), so this file
   only manages state.
   ========================================================================== */

(function () {
  'use strict';

  var OPEN = 'is-open';

  function closeItem(item) {
    if (!item) return;
    item.classList.remove(OPEN);
    var btn = item.querySelector('.orka-accordion__summary');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  function openItem(item) {
    item.classList.add(OPEN);
    var btn = item.querySelector('.orka-accordion__summary');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }

  function initGroup(group) {
    if (group.dataset.orkaAccordionReady === 'true') return;
    group.dataset.orkaAccordionReady = 'true';

    // Allow several independent groups (e.g. the FAQ's two desktop columns) to
    // behave as one, by pointing them at a shared name.
    var groupName = group.getAttribute('data-orka-accordion-group');

    group.addEventListener('click', function (evt) {
      var btn = evt.target.closest('.orka-accordion__summary');
      if (!btn || !group.contains(btn)) return;

      evt.preventDefault();

      var item = btn.closest('.orka-accordion__item');
      if (!item) return;

      var isOpen = item.classList.contains(OPEN);

      var scope = [group];
      if (groupName) {
        scope = Array.prototype.slice.call(
          document.querySelectorAll('[data-orka-accordion-group="' + groupName + '"]')
        );
      }

      scope.forEach(function (container) {
        container.querySelectorAll('.orka-accordion__item.' + OPEN).forEach(closeItem);
      });

      if (!isOpen) openItem(item);
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-orka-accordion]').forEach(initGroup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor — sections are re-rendered without a page load.
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  window.OrkaAccordion = { init: initAll };
})();
